
    (function() {
      const addSwiperClasses_template__30445704872284__collection_grid_Vtgyt7 = () => {
        const section = document.querySelector('#shopify-section-template--30445704872284__collection_grid_Vtgyt7');
        if (!section) return;

        const prevButtons = section.querySelectorAll('.global-nav-button.prev');
        const nextButtons = section.querySelectorAll('.global-nav-button.next');

        prevButtons.forEach(btn => btn.classList.add('section-template--30445704872284__collection_grid_Vtgyt7-prev'));
        nextButtons.forEach(btn => btn.classList.add('section-template--30445704872284__collection_grid_Vtgyt7-next'));
      };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addSwiperClasses_template__30445704872284__collection_grid_Vtgyt7);
      } else {
        addSwiperClasses_template__30445704872284__collection_grid_Vtgyt7();
      }

      document.addEventListener('shopify:section:load', function(e) {
        if (e.detail.sectionId === 'template--30445704872284__collection_grid_Vtgyt7') {
          addSwiperClasses_template__30445704872284__collection_grid_Vtgyt7();
        }
      });
    })();
  
;

(function() {
  const initProductImageSliders_template__30445704872284__collection_grid_Vtgyt7 = () => {
    const section = document.querySelector('#shopify-section-template--30445704872284__collection_grid_Vtgyt7');
    if (!section) return;

    const sliders = section.querySelectorAll('.product-slider');

    sliders.forEach(slider => {
      // Skip if already initialized
      if (slider.dataset.initialized === 'true') return;
      slider.dataset.initialized = 'true';

      const wrapper = slider.querySelector('.product-slider-wrapper');
      const slides = slider.querySelectorAll('.product-slide');
      const card = slider.closest('.product-card');
      const dots = card ? card.querySelectorAll('.dot') : [];

      if (slides.length <= 1) return;

      let currentSlide = 0;
      const slideCount = slides.length;

      // Update dots
      const updateDots = () => {
        if (dots && dots.length) {
          dots.forEach((dot, i) => {
            if (i === currentSlide) {
              dot.classList.add('active');
            } else {
              dot.classList.remove('active');
            }
          });
        }
      };

      // Update slider position
      const updateSlider = () => {
        // Wrapper width = slideCount * 100% (e.g., 4 slides = 400%)
        // Each slide takes up (100 / slideCount)% of wrapper width
        // To show slide N, translate by -(N * 100 / slideCount)% of wrapper
        // Example: 4 slides, show slide 2 → -(2 * 100/4) = -50% of wrapper = show second slide
        const percentagePerSlide = 100 / slideCount;
        const translateAmount = currentSlide * percentagePerSlide;
        wrapper.style.transform = `translateX(-${translateAmount}%)`;
      };

      // Handle swipe
      const handleSwipe = (startX, endX) => {
        const threshold = 50;

        if (startX - endX > threshold) {
          currentSlide = Math.min(currentSlide + 1, slideCount - 1);
          updateSlider();
          updateDots();
        } else if (endX - startX > threshold) {
          currentSlide = Math.max(currentSlide - 1, 0);
          updateSlider();
          updateDots();
        }
      };

      updateDots();

      // Touch swipe functionality
      let touchStartX = 0;
      let touchEndX = 0;

      slider.addEventListener('touchstart', e => {
        touchStartX = e.changedTouches[0].screenX;
      }, {passive: true});

      slider.addEventListener('touchend', e => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe(touchStartX, touchEndX);
      }, {passive: true});

      // Mouse drag functionality
      let isDragging = false;
      let startPosX = 0;

      slider.addEventListener('mousedown', e => {
        e.preventDefault();
        isDragging = true;
        startPosX = e.clientX;
        slider.style.cursor = 'grabbing';
      });

      slider.addEventListener('mousemove', e => {
        if (!isDragging) return;
        e.preventDefault();
      });

      const handleMouseUp = (e) => {
        if (!isDragging) return;

        isDragging = false;
        slider.style.cursor = 'grab';

        const moveX = e.clientX - startPosX;
        const threshold = slider.offsetWidth * 0.2;

        if (moveX < -threshold) {
          currentSlide = Math.min(currentSlide + 1, slideCount - 1);
        } else if (moveX > threshold) {
          currentSlide = Math.max(currentSlide - 1, 0);
        }

        updateSlider();
        updateDots();
      };

      slider.addEventListener('mouseup', handleMouseUp);
      slider.addEventListener('mouseleave', () => {
        if (isDragging) {
          isDragging = false;
          slider.style.cursor = 'grab';
        }
      });

      // Connect dots to slides
      if (dots && dots.length) {
        dots.forEach((dot, i) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            currentSlide = i;
            updateSlider();
            updateDots();
          });
        });
      }
    });
  };

  // Make function globally accessible for Swiper callback
  window.initProductImageSliders_template__30445704872284__collection_grid_Vtgyt7 = initProductImageSliders_template__30445704872284__collection_grid_Vtgyt7;

  // Also initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductImageSliders_template__30445704872284__collection_grid_Vtgyt7);
  } else {
    initProductImageSliders_template__30445704872284__collection_grid_Vtgyt7();
  }
})();

;

(function() {
  // Full card clickable functionality
  const initCardClickability = () => {
    const clickableCards = document.querySelectorAll('.collection-grid-section .product-card.full-card-clickable');
    
    clickableCards.forEach(card => {
      // Remove any existing listener to avoid duplicates
      const newCard = card.cloneNode(true);
      card.parentNode.replaceChild(newCard, card);
      
      // Add click handler
      newCard.addEventListener('click', function(e) {
        // Don't redirect if clicking on a link, button, or dot
        if (e.target.closest('a') || 
            e.target.closest('button') || 
            e.target.closest('.product-dots') ||
            e.target.closest('.dot')) {
          return;
        }
        
        const productUrl = this.getAttribute('data-product-url');
        if (productUrl) {
          window.location.href = productUrl;
        }
      });
      
      // Add pointer cursor feedback
      newCard.style.cursor = 'pointer';
    });
  };

  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCardClickability);
  } else {
    initCardClickability();
  }
  
  // Re-initialize when section is reloaded in theme editor
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.collection-grid-section')) {
      initCardClickability();
    }
  });
})();

// Grid navigation functionality
(function() {
  const initGridNavigation = () => {
    const section = document.querySelector('#shopify-section-template--30445704872284__collection_grid_Vtgyt7 .collection-grid-section');
    if (!section) return;
    
    const productGrid = section.querySelector('.product-grid:not(.swiper-wrapper)');
    if (!productGrid) return;
    
    const navButtons = section.querySelectorAll('.global-nav-button');
    const paginationDotsContainer = section.querySelector('.grid-pagination-dots');

    const cards = productGrid.querySelectorAll('.product-card');

    // Products per page = columns × rows
    const productsPerPage = 4 * 1;

    let currentPage = 0;
    const totalPages = Math.ceil(cards.length / productsPerPage);
    
    // Only show pagination if there's more than one page
    if (totalPages <= 1) {
      if (paginationDotsContainer) {
        paginationDotsContainer.style.display = 'none';
      }
      // Hide nav buttons if only one page
      navButtons.forEach(btn => btn.style.display = 'none');
      // Show all cards if only one page
      cards.forEach(card => {
        card.style.display = 'flex';
      });
      return;
    }

    // Show nav buttons if multiple pages
    navButtons.forEach(btn => btn.style.display = 'flex');
    
    // Create pagination dots
    if (paginationDotsContainer) {
      paginationDotsContainer.innerHTML = '';
      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'grid-pagination-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        dot.setAttribute('data-page', i);
        dot.addEventListener('click', () => showPage(i));
        paginationDotsContainer.appendChild(dot);
      }
    }
    
    function updateDots() {
      if (!paginationDotsContainer) return;
      const dots = paginationDotsContainer.querySelectorAll('.grid-pagination-dot');
      dots.forEach((dot, index) => {
        if (index === currentPage) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
    
    function showPage(pageIndex) {
      if (pageIndex < 0 || pageIndex >= totalPages) return;
      
      currentPage = pageIndex;
      const start = currentPage * productsPerPage;
      const end = start + productsPerPage;
      
      cards.forEach((card, index) => {
        if (index >= start && index < end) {
          card.style.display = 'flex';
        } else {
          card.style.display = 'none';
        }
      });
      
      // Update button states
      navButtons.forEach(btn => {
        if (btn.classList.contains('prev')) {
          btn.disabled = currentPage === 0;
        } else if (btn.classList.contains('next')) {
          btn.disabled = currentPage === totalPages - 1;
        }
      });
      
      // Update pagination dots
      updateDots();
    }
    
    // Add click handlers for nav buttons
    navButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        if (this.classList.contains('prev')) {
          showPage(currentPage - 1);
        } else if (this.classList.contains('next')) {
          showPage(currentPage + 1);
        }
      });
    });
    
    // Show first page
    showPage(0);
  };
  
  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGridNavigation);
  } else {
    initGridNavigation();
  }
  
  // Re-initialize when section is reloaded
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.collection-grid-section')) {
      initGridNavigation();
    }
  });
})();
